<template>
  <div class="list-item">
    <div class="left-content">
      <div class="me-3">
        <slot name="icon" />
      </div>
      <div class="main-info">
        <a :href="actionUrl" target="_blank"><h3 class="title" :class="classFromColorIndex(colorIndex, 'text-primary','text-secondary')">{{ displayTitle }}</h3></a>
        <div class="text-content-and-button">
          <div class="text-content">
            <slot name="content" />
          </div>
          <div class="button-area">
            <ActionButton class="rsvp-button" :action-url="actionUrl" :color-index="colorIndex">
              <template #action-button-text>
                <slot name="action-button-text" />
              </template>
            </ActionButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listItemMixin } from './list-item-mixin'

export default {
  mixins: [ listItemMixin ]
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.list-item {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px 20px 20px;
  min-height: 200px;
  background-color: white;
}

.left-content {
  display: flex;
  flex: 1;
}

.main-info {
  flex: 1;
}


.text-content-and-button {
  display: flex;
  flex-direction: column;
  flex: 1;
}

@include breakpoints.screen-lg-up {
  .text-content-and-button {
    flex-direction: row;
  }

  .button-area {
    flex-basis: 150px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    .rsvp-button {
      margin-top: 10px;
    }
  }
}

.text-content {
  font-size: 15px;
  margin-top: 10px;
  flex: 1;
}

.title {
  margin-top: 10px;
  margin-bottom: 0;
}

.action-button {
  margin: 20px 0 0 0;
}
</style>
